{
    "NAME": "Tipo di dispositivo Lingua",
    "DeviceTypesLanguage_Unknown": "Sconosciuto",
    "DeviceTypesLanguage_Trunk": "Tronco",
    "DeviceTypesLanguage_TrunkGateway": "Porta di accesso principale",
    "DeviceTypesLanguage_ChatService": "Servizio di chat",
    "DeviceTypesLanguage_EmailServer": "Server di posta elettronica",
    "DeviceTypesLanguage_ExtensionOrEndpoint": "Estensione\/Endpoint",
    "DeviceTypesLanguage_ExtensionOrEndpointTrunking": "Estensione (canalizzazione)",
    "DeviceTypesLanguage_ExtensionOrEndpointHospitality": "Estensione (Settore alberghiero)",
    "DeviceTypesLanguage_GroupSuper": "Supergruppo",
    "DeviceTypesLanguage_GroupCollective": "Gruppo (collettivo)",
    "DeviceTypesLanguage_GroupLinear": "Gruppo (lineare)",
    "DeviceTypesLanguage_GroupCyclic": "Gruppo (ciclico)",
    "DeviceTypesLanguage_GroupAcd": "Gruppo (ACD)",
    "DeviceTypesLanguage_GroupTrunk": "Gruppo (Bauletto)",
    "DeviceTypesLanguage_GroupVoicemail": "Gruppo (Segreteria telefonica)",
    "DeviceTypesLanguage_GroupPage": "Gruppo (Pagina)",
    "DeviceTypesLanguage_GroupDepartment": "Dipartimento",
    "DeviceTypesLanguage_GroupSecurityGroup": "Gruppo di sicurezza",
    "DeviceTypesLanguage_GroupSecurityGroupBroadworks": "Gruppi di fornitori di servizi",
    "DeviceTypesLanguage_GroupAcdMsTeams": "Code di chiamata",
    "DeviceTypesLanguage_Park": "Parco",
    "DeviceTypesLanguage_VoicemailApplication": "Applicazione di segreteria telefonica",
    "DeviceTypesLanguage_VoicemailAnnouncementHuntGroup": "Annuncio di coda (gruppo di caccia)",
    "DeviceTypesLanguage_VoicemailAnnouncementGeneral": "Annuncio di coda (Generale)",
    "DeviceTypesLanguage_AutoAttendant": "Auto Attendant",
    "DeviceTypesLanguage_MusicOnHold": "Musica in attesa",
    "DeviceTypesLanguage_Conference": "Conferenza",
    "DeviceTypesLanguage_PilotNumber": "Pilota \/ Alternativa",
    "DeviceTypesLanguage_DnisEntry": "Voce DNS"
}